import { Navbar } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import classNames from 'classnames';
import NavbarBrand from 'components/navbars/nav-items/NavbarBrand';
import NavItems from 'components/navbars/nav-items/NavItems';
import NavItemsSlim from 'components/navbars/nav-items/NavItemsSlim';
import QuickNavMenu from 'components/navbars/nav-items/QuickNavMenu';
import GlobalLeadSearch from 'components/common/GlobalLeadSearch';
import { useBreakpoints } from 'providers/BreakpointsProvider';
// Import mobile navbar styles
import './NavbarMobile.css';

const NavbarTopDefault = () => {
  const {
    config: { navbarTopShape, navbarTopAppearance }
  } = useAppContext();

  const { breakpoints } = useBreakpoints();

  return (
    <Navbar
      className={classNames('navbar-top fixed-top', {
        'navbar-slim': navbarTopShape === 'slim'
        // 'navbar-darker': navbarTopAppearance === 'darker'
      })}
      expand
      variant=""
      data-navbar-appearance={navbarTopAppearance === 'darker' ? 'darker' : ''}
      style={{
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(99, 102, 241, 0.1)',
        boxShadow: '0 4px 20px rgba(99, 102, 241, 0.08)'
      }}
    >
      <div className="navbar-collapse justify-content-between">
        <div className="d-flex align-items-center">
          <NavbarBrand />
          {/* Quick Navigation Menu */}
          {breakpoints.up('lg') && <QuickNavMenu />}
        </div>

        {/* Global AI-Enhanced Search Bar */}
        {breakpoints.up('lg') ? (
          <div className="d-flex justify-content-center flex-grow-1 mx-4">
            <GlobalLeadSearch />
          </div>
        ) : null}

        {navbarTopShape === 'default' ? (
          <>
            {/* Original commented search - keeping for reference but using our new GlobalLeadSearch */}
            {/* {breakpoints.up('lg') && (
              <DropdownSearchBox
                className="navbar-top-search-box"
                inputClassName="rounded-pill"
                size="sm"
                style={{ width: '25rem' }}
              >
                <SearchResult />
              </DropdownSearchBox>
            )} */}
            <NavItems />
          </>
        ) : (
          <NavItemsSlim />
        )}
      </div>
    </Navbar>
  );
};

export default NavbarTopDefault;
